import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from './../../../../src/environments/environment';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat } from 'ol/proj';
import { Fill, Stroke, Style } from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import Text from 'ol/style/Text';
import Point from 'ol/geom/Point';
import { transform } from 'ol/proj';
import CircleStyle from 'ol/style/Circle';
import Icon from 'ol/style/Icon';
import { toStringHDMS } from 'ol/coordinate';
import Overlay from 'ol/Overlay';
import { toLonLat } from 'ol/proj';
import { Draw, Select, Modify, Snap } from 'ol/interaction';
//import GeoJSON from 'ol/format/GeoJSON';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { RequestService } from '../../../services/request.service';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { data } from 'jquery';

@Component({
  selector: 'app-device-location',
  templateUrl: './device-location.component.html',
  styleUrls: ['./device-location.component.scss']
})
export class DeviceLocationComponent implements OnInit {

  isLoading: boolean = false;
  showTable: boolean = false;
  progressbar: any = {}
  totalDevices: number = 0;
  totalActiveDevices: number = 0;
  totalInactiveDevices: number = 0;
  totalToilet: number = 0;

  errorMessage: string = '';

  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private loader: NgxUiLoaderService,
    private cdr: ChangeDetectorRef
  ) { }

  vector;
  source;
  ngOnInit() {
    this.totalInstallDevice();

    this.DeviceLogReportForMap("All");

    this.source = new VectorSource();
    this.vector = new VectorLayer({
      source: this.source,
      style: new Style({
        stroke: new Stroke({
          color: 'black',
          width: 5
        })
      })
    });

    this.LoadMap();
  }

  map: Map;
  googleLayerHybrid: any;
  googleLayerHybrid2: any;
  public anchors;
  LoadMap() {
    this.googleLayerHybrid2 = new TileLayer({
      source: new XYZ({
        //url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        url: 'https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'
      })
    });

    this.googleLayerHybrid = new TileLayer({
      source: new XYZ({
        url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
      })
    });

    /* Elements that make up the popup. */
    // this.container = $("#popup").val(); //document.getElementById('popup');
    // this.content = $("#popup-content").val(); //document.getElementById('popup-content');
    // this.closer = $("#popup-closer").val(); //document.getElementById('popup-closer');

    let container1 = document.getElementById('popup');
    let content1 = document.getElementById('popup-content');
    let closer1 = document.getElementById('popup-closer');


    closer1.onclick = function () {
      overlay1.setPosition(undefined);
      closer1.blur();
      return false;
    };
    let overlay1 = new Overlay({
      element: container1,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    this.map = new Map({
      target: 'map',
      overlays: [overlay1],
      layers: [this.googleLayerHybrid2, this.vector],
      view: new View({
        center: fromLonLat([75.896823, 22.74764]),
        zoom: 12,
        minZoom: 2,
        maxZoom: 20
      }),
    });

    this.map.on('singleclick', function (evt) {
      //alert(evt.coordinate);
      let feature = evt.map.forEachFeatureAtPixel(evt.pixel,
        function (feature, layer) {
          return feature;
        });
      if (feature) {
        //alert(feature.get('type'));
        if (feature.get('type') == "device_position") {
          let device_id = feature.get('device_id');
          let address = feature.get('address');
          let toilet_name = feature.get('toilet_name');
          let lattitude = feature.get('lattitude');
          let longitude = feature.get('longitude');
          let air_quality_status = feature.get('air_quality_status');
          let log_date_time = feature.get('log_date_time');
          let people_count = feature.get('people_count');
          let water_lavel = feature.get('water_lavel');
          let person_count = feature.get('person_count');
          let feedback = feature.get('feedback');
          let feedback_icon = "";
          if (feedback == "Excellent") {
            feedback_icon = "assets/images/excellent.png";
          } else if (feedback == "Good") {
            feedback_icon = "assets/images/good.png";
          } else if (feedback == "Poor") {
            feedback_icon = "assets/images/bad.png";
          } else {
            feedback_icon = "assets/images/not_available.png";
          }
          let device_information = `
          <style>
            .track_table_idle{
              padding: .25rem !important;
              vertical-align: top;
              border-top: 1px solid #dee2e6;
              white-space: normal !important;
              word-break: normal !important;
              word-wrap: break-word !important;
            }
          </style>
          <table class="table table-bordered table-striped" style="font-size:14px;">
              <tr>
                  <th style="background-color:#0a766c; color:white;" colspan="2" class="text-center track_table_idle">Toilet Details</th>
              </tr>
              <tr>
                  <th width="50%" class="track_table_idle"><b>Device ID</b></th>
                  <td class="track_table_idle">`+ device_id + `</td>
              </tr>
              <tr>
                  <th width="50%" class="track_table_idle"><b>Toilet Name</b></th>
                  <td class="track_table_idle">`+ toilet_name + `</td>
              </tr>
              <tr>
                  <td colspan="2" class="track_table_idle">`+ address + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Coordinates</b></td>
                <td class="track_table_idle">`+ lattitude + `,` + longitude + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Air Quality</b></td>
                <td class="track_table_idle">`+ air_quality_status + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Water Level</b></td>
                <td class="track_table_idle">`+ water_lavel + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Person Count</b></td>
                <td class="track_table_idle">`+ person_count + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Log Date Time</b></td>
                <td class="track_table_idle">`+ log_date_time + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Feedback</b></td>
                <td class="track_table_idle">`+ feedback + ` 
                  <img id="icon" width="25" height="25" src="`+ feedback_icon + `">
                </td>
              </tr>
          </table>`;

          let coordinate = transform([parseFloat(longitude), parseFloat(lattitude)], 'EPSG:4326', 'EPSG:3857');
          let hdms = toStringHDMS(coordinate);
          content1.innerHTML = device_information;
          overlay1.setPosition(coordinate);
        } else {

        }
      }
    });

  }

  rowData;
  async DeviceLogReportForMap(feedback_type) {
    const logData = {};
    this.rowData = [];
    try {
      const response: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', logData);
      for (let objKey of Object.keys(response.result)) {
        let dataObj = response.result[objKey];
        // console.log(dataObj);
        this.ShowMarker(dataObj.water_lavel, dataObj.person_count, dataObj.lattitude, dataObj.longitude, dataObj.toilet_name, dataObj.address, dataObj.device_id, dataObj.air_quality_status, dataObj.log_date_time, dataObj.feedback);
      }

      // console.log(JSON.stringify(this.rowData));
      // await new Promise(resolve => setTimeout(() => resolve(this.DeviceLogReport(feedback_type)), 30000));

    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }

  dataDate: any;
  curDate: any;
  delta: any;
  vectorLayer: any = [];
  ShowMarker(water_lavel, person_count, lat, lon, toilet_name, address, device_id, air_quality_status, log_date_time, feedback) {
    if (lat == 0 || lon == 0) return;
    let centerPoint = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');

    let iconFeature = new Feature({
      type: "device_position",
      geometry: new Point(centerPoint),
      device_id: device_id,
      address: address,
      toilet_name: toilet_name,
      lattitude: lat,
      longitude: lon,
      device_icon: "assets/images/device_icon.png",
      air_quality_status: air_quality_status,
      water_lavel: water_lavel,
      person_count: person_count,
      log_date_time: log_date_time,
      feedback: feedback,
      population: 4000,
      rainfall: 500
    });

    let opacity = 1;
    let icon;
    let offsetY = -15;
    icon = 'assets/images/device_icon.png';
    let iconStyle = new Style({
      image: new Icon(({
        anchor: [0.5, 15],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        opacity: opacity,
        offset: [0, 0],
        src: icon
      })),
      text: new Text({
        font: 'bold 12px verdana,Calibri,sans-serif',
        fill: new Fill({ color: '#F00' }),
        offsetY: offsetY,
        stroke: new Stroke({
          color: '#fff', width: 1
        }),
        text: device_id
      })
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new VectorSource({
      features: [iconFeature]
    });

    let bShow = true;
    if (bShow) {
      if (this.vectorLayer[device_id] !== null) {
        this.map.removeLayer(this.vectorLayer[device_id]);
      }

      this.vectorLayer[device_id] = new VectorLayer({
        source: vectorSource
      });
      this.map.addLayer(this.vectorLayer[device_id]);
    }
  }

  InstallDevices() {
    this.router.navigate(['/form/install-device-report']);
  }
  ActiveDevices() {
    this.router.navigate(['/form/active-device-report']);
  }
  InactiveDevices() {
    this.router.navigate(['/form/inactive-device-report']);
  }
  ToiletReports() {
    this.router.navigate(['/form/toilet-report']);
  }

  async totalInstallDevice(): Promise<void> {
    const getInstallData = {};
    try {
      const response: any = await this.request.post('/dashboard/view_dashboard_data', getInstallData);
      // console.log(response);
      if (response.status === "SUCCESS") {
        const result = response.result;
        this.totalDevices = result.total_devices;
        this.totalActiveDevices = result.total_active_devices;
        this.totalInactiveDevices = result.total_inactive_devices;
        this.totalToilet = result.total_toilets;

      } else {
        this.errorMessage = 'Failed to load dashboard data.';
      }
    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }

}
